// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_hl","advertCardNum":"c-a_hm"};